/**
 * Styles for icon component
 */
var style = {
    display: 'block',
    userSelect: 'none',
    fill: 'transparent',
    // sharper rendering w/ good antialiasing
    shapeRendering: 'geometricPrecision',
    // allow antialiasing sub-pixels to overflow edges
    overflow: 'visible',
};

export { style };
//# sourceMappingURL=common.esm.js.map
